export default class TicketField {
  constructor(
    public id: string,
    public name: string,
    public code: string,
    public type: string,
    public values: string[],
    public defaultValues?: string[]
  ) {}

  toString() {
    return this.name;
  }
}

export const FieldTypeJp = {
  String: "文字列",
  ArrayString: "文字列(複数)",
  Number: "数字",
  SingleSelect: "セレクト",
  Radio: "ラジオボタン",
  Checkbox: "チェックボックス",
  Boolean: "Yes/No",
  Datetime: "日時",
  Date: "日付",
  Time: "時間",
  Textarea: "テキストエリア",
  Category: "管理種別",
  Reason: "お問い合わせ理由",
  Agent: "担当者"
}
export const FieldType = {
  String: "String",
  ArrayString: "ArrayString",
  Number: "Number",
  SingleSelect: "SingleSelect",
  Radio: "Radio",
  Checkbox: "Checkbox",
  Boolean: "Boolean",
  Datetime: "Datetime",
  Date: "Date",
  Time: "Time",
  Textarea: "Textarea",
  Category: "Category",
  Reason: "Reason",
  Agent: "Agent"
}
export const TICKET_FIELD = 'ticket_fields';
export const ticketFieldConverter = {
  toFirestore(ticketField) {
    return {
      id: ticketField.id,
      name: ticketField.name,
      code: ticketField.code,
      type: ticketField.type,
      values: ticketField.values,
    }
  },

  fromFirestore(
    snapshot,
    options
  ): TicketField {
    const data = snapshot.data(options);
    return new TicketField(snapshot.id,
      data.name,
      data.code,
      data.type,
      data.values
    );
  }
}